import React from 'react';
import { ViewStyle  } from 'react-native';
import { Container, StyledText } from '@fkhplus/common/src/components/atoms/Timer/styles';



interface IProps {
  timeLimit: number;
  onTimerEnd?: () => void;
  style?: ViewStyle;
}

interface IScreenState {
  LHS: number;
  RHS: number;
  notUpdate: null | boolean;
}

class Timer extends React.Component<IProps, IScreenState> {
   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
   // @ts-ignore
  interval: any;

  constructor(props: IProps | Readonly<IProps>) {
    super(props);
    this.state = { LHS: 0, RHS: 0, notUpdate: null };
  }

  public componentDidMount(): void {
    this.resetTimer()
  }

  public resetTimer =(): void=>{
    this.clearIntervalFunc()
    const { timeLimit } = this.props;
    if (timeLimit != 0) {
      this.setState({ LHS: Math.floor(timeLimit / 60), RHS: timeLimit % 60 });
      this.setIntervalfunc();
    }
    if (timeLimit == 0) {
      this.setState({ LHS: 0, RHS: 0 });
    }
  }

  public clearIntervalFunc(): void {
    clearInterval(this.interval);
  }

  public setIntervalfunc(): void {
    this.interval = setInterval(() => {
      this.setState((prevState) => ({ RHS: prevState.RHS - 1 }));
    }, 1000);
  }

  public componentDidUpdate(): void {
    const { LHS, RHS, notUpdate } = this.state;
    const { onTimerEnd } = this.props;
    if (notUpdate) {
      return;
    }
    if (RHS == 0 && LHS == 0 ) {
      clearInterval(this.interval);
      onTimerEnd && onTimerEnd();
      this.setState({ notUpdate: true });
      return;
    }

    if (RHS === 0) {
      clearInterval(this.interval);
      this.setState({ LHS: (LHS * 60 - 60) / 60, RHS: 60 });
      this.setIntervalfunc();
    }
  }

  public componentWillUnmount(): void {
    clearInterval(this.interval);
  }

  public render(): React.ReactNode {
    const { LHS, RHS } = this.state;
    const {style} = this.props;

    return (
      <Container style={style}>
            <StyledText textStyle={{fontWeight:'bold',type:'bodyRegular'}}>{LHS}:{RHS >= 10 ? RHS : `0${RHS}`}</StyledText>
      </Container>
    );
  }
}


export default Timer;